import { Button, Form, Input, Select } from 'antd';
import { Rule } from 'antd/es/form';
import type { SelectProps } from 'antd';
import { Country } from 'entities/countries/model/types';
import { SignUpFormData } from 'pages/auth/registration/model/types';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import classes from './LocationSection.module.css';

type Props = {
  countries: Country[];
  formRules: Record<string, Rule[]>
  formData: Partial<SignUpFormData>
}

export const LocationSection: FC<Props> = ({ countries, formRules, formData }) => {
  const { formatMessage: t } = useIntl();

  const filterOption = (input: string, option?: { label: string; value: string }) => {
    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  };

  const builtinPlacements: SelectProps['builtinPlacements'] = {
    bottomLeft: {
      points: ['tl', 'bl'],
      offset: [0, 4],
      overflow: {
        adjustX: true,
        adjustY: true,
      },
    },
  };

  return (
    <Form name='location' initialValues={formData} className={classes.locationForm}>
      <Form.Item name='country' rules={formRules.country}>
        <Select
          showSearch
          filterOption={filterOption}
          placement="bottomLeft"
          builtinPlacements={builtinPlacements}
          getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
          placeholder={t({ id: 'inputs.country' })}>
          {countries
            .filter((country) => country.eea || country.iso2 === 'GB')
            .map((country, idx) => (
              <Select.Option
                id={`country${idx}`}
                label={country.name}
                value={country.id}
                key={country.id}>
                <div id={`country${idx}`} style={{ display: 'flex' }}>
                  <div
                    className={`fi fi-${country.iso2.toLowerCase()}`}
                    style={{ marginRight: 6 }}
                  />
                  <div>{country.name}</div>
                </div>
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
      <Form.Item name='city' rules={formRules.city}>
        <Input placeholder={t({ id: 'openAccount.modal.info.city' })} />
      </Form.Item>
      <Form.Item name='address' rules={formRules.address}>
        <Input placeholder={t({ id: 'openAccount.modal.info.address' })} />
      </Form.Item>
      <Form.Item name='postalCode' rules={formRules.postalCode}>
        <Input placeholder={t({ id: 'openAccount.modal.info.postal' })} />
      </Form.Item>
      <Form.Item>
        <Button color="primary" variant='solid' htmlType='submit' block>{t({ id: 'buttons.next' })}</Button>
      </Form.Item>
    </Form>
  )
}